import * as CSS from "csstype"
import { system } from "styled-system"

const cursor = system({
  cursor: true,
})

export interface CursorProps {
  cursor?: CSS.Property.Cursor | CSS.Property.Cursor[]
}

export default cursor
